import { createCrudService } from './createCrudService';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface WorkflowStep {
  id: string;
  workflow_definition_id: string;
  step_type: string;
  name: string;
  sort_order: number;
  execution_mode: 'sync' | 'async';
  config: Record<string, unknown>;
  condition: Record<string, unknown> | null;
  is_active: boolean;
  timeout_seconds: number | null;
  retry_policy: Record<string, unknown> | null;
  created_at: string;
  updated_at: string;
}

export interface WorkflowDefinition {
  id: string;
  tenant_id: number;
  parent_definition_id: string | null;
  slug: string;
  name: string;
  description: string | null;
  version: number | null;
  is_active: boolean;
  config: Record<string, unknown> | null;
  created_at: string;
  updated_at: string;
  steps_count?: number;
  executions_count?: number;
  rules_count?: number;
  steps?: WorkflowStep[];
}

// No create/update payloads needed for now - definitions are read-only in this view
// But include them for completeness following the pattern
export interface StoreWorkflowDefinitionRequest {
  slug: string;
  name: string;
  description?: string;
  parent_definition_id?: string;
  version?: number;
  is_active?: boolean;
  config?: Record<string, unknown>;
}

export interface UpdateWorkflowDefinitionRequest {
  slug?: string;
  name?: string;
  description?: string;
  parent_definition_id?: string | null;
  version?: number;
  is_active?: boolean;
  config?: Record<string, unknown>;
}

// ---------------------------------------------------------------------------
// Service
// ---------------------------------------------------------------------------

export const workflowDefinitionsService = createCrudService<
  WorkflowDefinition,
  StoreWorkflowDefinitionRequest,
  UpdateWorkflowDefinitionRequest
>('/admin/workflows');
